/*eslint-disable*/
import axios from "axios"
export default {
	namespaced: true,
	state: {
		error: false,
		deleting: false,
		restoring: false,
		payment: undefined,
		payments: {
			array: [],
			count: 0
		},
		loading: false,
		pagination: {
			size: 50,
			offset: 0
		}
	},
	getters: {
		deleting: state => state.deleting,
		restoring: state => state.restoring,
		payment: state => state.payment,
		payments: state => state.payments,
		loading: state => state.loading,
		pagination: state => state.pagination
	},
	mutations: {
		mutate(state, payload) {
			state[payload.element] = payload.value
		},

		LOAD_ARRAY(state, payload) {
			state.payments = {
				array: payload.array,
				count: payload.count
			}
		},
		ADD(state, element) {
			if (state.payments.array.length + 1 < state.pagination.size) state.payments.array.push(element)
			state.payments.count += 1
		}
	},

	actions: {
		doMutate({ commit }, payload) {
			commit("mutate", payload)
		},

		async doPayments({ commit }) {
			var r = []
			await axios
				.post(
					process.env.VUE_APP_API_URL + "/api/payments/all",
					{},
					{ headers: { Authorization: "Bearer " + localStorage.getItem("JWT") } }
				)
				.then(res => {
					r = res.data.array
				})
				.catch(err => {
					r = []
				})
			return r
		},

		async doGetByFilters({ commit }, filters) {
			commit("mutate", { element: "error", value: false })
			commit("mutate", { element: "loading", value: true })
			await axios
				.post(process.env.VUE_APP_API_URL + "/api/payments/filters", filters, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					commit("LOAD_ARRAY", res.data)
					commit("mutate", { element: "error", value: false })
				})
				.catch(err => {
					commit("mutate", { element: "error", value: true })
				})
				.finally(_ => commit("mutate", { element: "loading", value: false }))
		},

		async doGetById({ commit }, id) {
			var r = undefined
			await axios
				.get(process.env.VUE_APP_API_URL + "/api/payments/get/" + id, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					r = res.data
					commit("mutate", { element: "error", value: false })
				})
				.catch(err => {
					commit("mutate", { element: "error", value: true })
				})

			return r
		},

		async doDelete({ state, commit }, array) {
			var r = undefined
			await axios
				.post(
					process.env.VUE_APP_API_URL + "/api/payments/batchDelete",
					{ array: array },
					{ headers: { Authorization: "Bearer " + localStorage.getItem("JWT") } }
				)
				.then(res => {
					for (var i = 0; i < state.payments.array.length; i++) {
						if (res.data.deleted && res.data.deleted.includes(state.payments.array[i].id)) {
							state.payments.array.splice(i, 1)
							state.payments.count -= 1
							i--
						}
					}
					r = { status: true, msg: "" }
				})
				.catch(err => {
					r = { status: false, msg: err.response.data.Message }
				})
				.finally(_ => {
					commit("mutate", { element: "deleting", value: false })
				})

			return r
		},

		async doAdd({ state, commit }, { payload, subscription, organization }) {
			var r = undefined
			await axios
				.post(process.env.VUE_APP_API_URL + "/api/payments/add", payload, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					r = { status: true, value: res.data }
					res.data.subscription = subscription
					res.data.organization = organization
					commit("ADD", res.data)
				})
				.catch(err => {
					r = { status: false, value: err.response }
				})

			return r
		}
	}
}
